import { render, staticRenderFns } from "./SubscriptionForm.vue?vue&type=template&id=56e0efa5&scoped=true"
import script from "./SubscriptionForm.vue?vue&type=script&lang=js"
export * from "./SubscriptionForm.vue?vue&type=script&lang=js"
import style0 from "./SubscriptionForm.vue?vue&type=style&index=0&id=56e0efa5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e0efa5",
  null
  
)

export default component.exports